import type { ChatBotsCollectionState } from './chat-bots.reducer';
import type { CollectionsState } from '../collections-feature.reducer';

import { createSelector } from '@ngrx/store';
import { CHAT_BOTS_COLLECTION_FEATURE_KEY, chatBotsAdapter } from './chat-bots.reducer';
import { collectionsState } from '../collections-state.selectors';

const { selectCollectionQueryItem, selectCollectionQueryStatuses } = chatBotsAdapter.getSelectors();

export const selectChatBotsState = createSelector(
    collectionsState,
    (state: CollectionsState): ChatBotsCollectionState => state[CHAT_BOTS_COLLECTION_FEATURE_KEY]
);

export const selectChatBots = (id: string) => createSelector(selectChatBotsState, selectCollectionQueryItem(id));

export const selectChatBotsStatuses = (id: string) =>
    createSelector(selectChatBotsState, selectCollectionQueryStatuses(id));
